import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 3BCACB97-3EEE-453B-81A7-1136F167B23D
 * name home-battery
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-battery.svg
 * tags
 * - Home Automation 
 * - Battery 
 */
export const HomeBatteryIcon = createSvgIcon(<><path d="M12 20L5 20V12H2L12 3L14.78 5.5H14V7.17C12.84 7.58 12 8.7 12 10V20M15 9H16V7.5H20V9H21C21.55 9 22 9.45 22 10V21C22 21.55 21.55 22 21 22H15C14.45 22 14 21.55 14 21V10C14 9.45 14.45 9 15 9M16 11V14H20V11H16Z" /></>, 'HomeBatteryIcon');
export default HomeBatteryIcon